import { FETCH_PRODUCT_REQUEST_DETAILS, RESET_PRODUCT_REQUEST_DETAILS, APPROVE_REJECT_DATA_PRODUCT_REQUEST } from '../../constants/reducerTypes';

const initialState = {
  data: null,
  loading: false,
  error: null,
  approveLoading: false,
  approveData: null,
  approveError: null,
};

const productRequestDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_REQUEST_DETAILS:
      return {
        ...state,
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      };
    case RESET_PRODUCT_REQUEST_DETAILS:
      return initialState;
    case APPROVE_REJECT_DATA_PRODUCT_REQUEST:
      return {
        ...state,
        approveData: action.payload.data,
        approveLoading: action.payload.loading,
        approveError: action.payload.error,
      };
    default:
      return state;
  }
};

export default productRequestDetailsReducer;
